import React from "react";
import Footer from "./footer";
import Header from "./header";
import PageRouter from "../pages/PageRouter";

const AppContent = () => {
  return (
    <div style={{backgroundColor:"black"}}>
      <Header />
      <PageRouter/>
      <Footer />
    </div>
  );
};

export default AppContent;
